import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import { RATING, RATING_TYPE } from '../../../../../constant';
import { LabelName, Required } from '../../../../../utils';

function Rating({ data, setData, setError, ind, isRequired, globalStateData }) {
  const { fieldName, ratingValidation = {} } = data;
  const { scaleLimit = 5, ratingType = 'STAR' } = ratingValidation;

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  const [selectedRating, setSelectedRating] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue ?? '',
  );

  useEffect(() => {
    setError(null);
    if (isRequired && selectedRating === null) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }
    setData(Number(selectedRating), ind);
  }, [selectedRating]);

  const selectedIconObj = RATING_TYPE.find((type) => type.name === ratingType);
  const SelectedIcon = selectedIconObj ? selectedIconObj.label : RATING_TYPE[0].label;

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Grid item>
        <LabelName>
          {fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>

      <Grid
        item
        container
        style={{
          marginLeft: '1rem',
          display: 'flex',
          gap: '0.75rem',
          justifyContent: 'space-around',
        }}
      >
        {RATING.map(
          (key) =>
            key <= scaleLimit && (
              <div
                key={key}
                role="button"
                tabIndex="0"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  borderRadius: '5px',
                  opacity: isDisabled ? 0.5 : 1,
                }}
                onClick={() => {
                  if (!isDisabled) setSelectedRating(key);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setSelectedRating(key);
                  }
                }}
              >
                <h4>{key}</h4>
                {React.createElement(SelectedIcon, {
                  style: {
                    width: 30,
                    height: 30,
                    color: !isDisabled && key <= selectedRating ? '#00B6A4' : '',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled ? 0.5 : 1,
                  },
                })}
              </div>
            ),
        )}
      </Grid>
    </Grid>
  );
}

export default Rating;
